module.exports = __webpack_public_path__ + "img/theme-five.83a825ca.png";